<mat-card class="requestAccountCard">
    <mat-card-header mat-dialog-title>
        <mat-card-title class="text-uppercase text-left login-header accountRequestHeader">Request Account</mat-card-title>
    </mat-card-header>
    <mat-card-content mat-dialog-content class="position-relative align-content-between">
        <p>Please enter your information and we will send you an email confirmation with a temporary password within 48 hours.</p>
            <div class="row">
                <div class="col d-flex mx-auto fit-width">
                    <mat-form-field class="col">
                        <mat-label class="text-uppercase">First Name</mat-label>
                        <input matInput [(ngModel)]="accountRequest.firstName" cdkfocusinitial required>
                    </mat-form-field>
                    <mat-form-field class="col">
                        <mat-label class="text-uppercase">Last Name</mat-label>
                        <input matInput [(ngModel)]="accountRequest.lastName" required>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex mx-auto fit-width">
                    <mat-form-field class="col">
                        <mat-label class="text-uppercase">Credit Union</mat-label>
                        <mat-select required [(value)]="accountRequest.cuid">
                            <mat-option *ngFor="let cu of creditUnions | async" [value]="cu.cuid">{{cu.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col">
                        <mat-label class="text-uppercase">Job Title</mat-label>
                        <input matInput [(ngModel)]="accountRequest.jobTitle">
                    </mat-form-field>
                </div>
            </div>
        <div class="row">
            <div class="col d-flex mx-auto fit-width">
                <mat-form-field class="col">
                    <mat-label class="text-uppercase">Phone Number</mat-label>
                        <input matInput [(ngModel)]="accountRequest.phoneNumber" required maxlength="10" placeholder="000-000-0000">
                    </mat-form-field>
                    <mat-form-field class="col">
                        <mat-label class="text-uppercase">Email Address</mat-label>
                        <input matInput [(ngModel)]="accountRequest.email" email required placeholder="Example@example.com">
                    </mat-form-field>
            </div>
        </div>

        <div class="text-center">
            <p><b><i>If you need an account sooner, please call us at 801-365-5000.</i></b></p>
        </div>
        <mat-dialog-actions>
            <div class="text-center w-100">
                <button mat-raised-button class="btn-primary requestBtn" type="submit" color="primary" [mat-dialog-close]="true" (click)="requestAccount()">Request</button>
                <button mat-raised-button [mat-dialog-close]="true" class="btn cancelBtn">Cancel</button>
            </div>
        </mat-dialog-actions>
    </mat-card-content>
</mat-card>
